<template lang="pug">
#description
  //- 一般
  custom-table(
    v-if="productCategorySelectStyle == '1' && productDetail.DetailType == '1'",
    :table="productDetail"
  )
  //- 健康
  custom-image(
    :image="productDetail",
    v-if="productCategorySelectStyle == '1' && productDetail.DetailType == '2'"
  )
  //- 企業
  business-table(
    :table="productDetail",
    v-if="productCategorySelectStyle == '2' && productDetail.DetailType == '1'"
  )

  section
    expand-head.i_mt_6(
      @click.native="setRelatedQuesExpand",
      :title="relatedQuesTitle",
      :icon="'ic_QA_insurancecontent'",
      :selected="relatedQuesExpand",
      :class="{ business: $store.state.navigationStyle == 2 }"
    )
    transition(name="fade-height")
      .container(v-show="relatedQuesExpand")
        .related_ques_content(
          v-for="(QuestionContent, index) in currentQAList",
          :key="index"
        )
          qa-html-item.i_pt_6(:QuestionContent="QuestionContent")
        .row
          .col-12.text.center.justify-content-center
            b-pagination(
              v-model="currentPage",
              :total-rows="totalRows",
              :per-page="perPage",
              first-number,
              last-number,
              :class="{ business: $store.state.navigationStyle == 2 }"
            )
    .container.i_mt_6.i_mb_10
      router-link.btn_round(
        v-if="true",
        tag="a",
        :to="{ name: 'CustomerServiceContactUs' }",
        :class="{ btn_blue: $store.state.navigationStyle == 2 }"
      ) 聯絡我們
</template>

<script>
import Table from "@/components/product/Description/Table";
import BusinessTable from "@/components/product/Description/BusinessTable";
import Image from "@/components/product/Description/Image";
import QAHtmlItem from "@/components/customer_service/QAHtmlItem";
import ExpandHead from "@/components/common/ExpandHead";
import { getFAQDetail } from "@/json/FAQ";

export default {
  name: "ProductDescription",
  components: {
    "custom-table": Table,
    "custom-image": Image,
    "qa-html-item": QAHtmlItem,
    "business-table": BusinessTable,
    "expand-head": ExpandHead,
  },
  props: {
    productDetail: Object,
    productCategorySelectStyle: String,
  },
  data() {
    return {
      relatedQuesTitle: "保險內容相關問題",
      relatedQuesExpand: true,
      totalRows: 0,
      perPage: 5,
      currentPage: 1,
      currentQAList: [],
      QAList: [],
    };
  },
  watch: {
    currentPage() {
      this.getCurrentList();
    },
  },
  created() {
    this.getFAQDetail();
  },
  methods: {
    setRelatedQuesExpand() {
      this.relatedQuesExpand = !this.relatedQuesExpand;
    },
    expand() {
      this.isExpand = !this.isExpand;
    },
    getFAQDetail() {
      getFAQDetail().then((response) => {
        let FAQDetail = response.data.FAQDeatilList;
        for (let x in FAQDetail) {
          let detail = FAQDetail[x];
          if (
            this.productDetail.Detail_area02_FAQCategoryID ==
            detail.FAQCategoryID
          ) {
            this.QAList.push(detail);
          }
        }
        this.totalRows = this.QAList.length;
        this.getCurrentList();
      });
    },
    getCurrentList() {
      this.currentQAList = [];
      let number = this.perPage * this.currentPage;
      this.currentQAList = this.QAList.slice(number - this.perPage, number);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/common/pagination";

::v-deep .business {
  .title_bar {
    background-color: $color_blue;
  }

  .page-item.active .page-link {
    color: $color_blue;
  }
}
</style>

